import axios from "axios";
import store from "../store/index";
import {router} from '../router'

import Vue from 'vue';
import VueSwal from 'vue-swal'
Vue.use(VueSwal)

const ROOT_URL = process.env.VUE_APP_BACKEND_API_URL;
// const CLIENT_ID = process.env.VUE_APP_CP_API_CLIENT_ID;
// const CLIENT_SECRET = process.env.VUE_APP_CP_API_CLIENT_SECRET;

// const login = (username, password) => {
//     const querystring = {
//         username: username,
//         password: password,
//         client_id: CLIENT_ID,
//         client_secret: CLIENT_SECRET,
//         grant_type: "password",
//         scope: ""
//     };

//     const requestOptions = {
//         url: `${ROOT_URL}/oauth/token`,
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json"
//         },
//         data: querystring
//     };

//     return axios(requestOptions)
//         .then(response => {
//             return response.data;
//         });
// };

/**
 * Request Api with user authentication
 */
const requestApi = (method, uri, querystring = {}) => {
    // get token from vuex
    const token = store.state.auth.token;

    if (!token) {
        console.log("token:", token);
        // store.dispatch("auth/logout");
        return;
    }

    const locale = localStorage.getItem('locale') || 'kh';

    const requestOptions = {
        url: `${ROOT_URL}/api/${uri}`,
        method: method,
        headers: {
            "Content-Type": "application/json",
            "Locale": locale,
            Authorization: `${token.token_type} ${token.access_token}`
        },
        data: querystring
    };

    return axios(requestOptions)
        .then(__handleResponse)
        .catch(__handleError);
}

const __handleResponse = response => {
    // if (!response.data.status) {
    //     console.log(response.data);
    //     return Promise.reject(response.data);
    // }
    return response.data;
}


const __handleError = error => {
    if(store.state.loading.status){
        store.state.loading.status = false;
    }

    if(typeof error.response !== 'undefined'){
        if (error.response.status === 401) {
            const appPrefix = process.env.VUE_APP_PREFIX;;
            localStorage.removeItem(appPrefix + 'token');

            const originalRequest = error.config;
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                const refreshToken = store.state.auth.token.refresh_token;
                //make refresh token request
                const querystring = {
                    client_id: CLIENT_ID,
                    client_secret: CLIENT_SECRET,
                    grant_type: "refresh_token",
                    refresh_token: refreshToken,
                    scope: ""
                };

                const requestOptions = {
                    url: `${ROOT_URL}/oauth/token`,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: querystring
                };

                return axios(requestOptions).then(response => {
                    store.dispatch("auth/updateToken", response.data);
                    originalRequest.headers['Authorization'] = 'Bearer ' + store.state.auth.token.access_token;
                    return axios(originalRequest)
                        .then(__handleResponse)
                        .catch(__handleError);
                }).catch(error => {
                    store.dispatch("auth/logout");
                });
            }
            store.dispatch("auth/logout");
        }else if(error.response.status === 422) {
            return Promise.reject(error.response);
        }else if(error.response.status === 404) {
            swal({
                icon: 'error',
                title: 'Oops...',
                text: error.response.statusText,
            }).then(() => {
                router.push('/error/404');
            });
        }else{
            swal({
                icon: 'error',
                title: error.response.statusText,
                text: error.response.data.message,
            });
            return Promise.reject(error);
        }
    }

}

export default {
    // login,
    requestApi
};